import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		token: {},
		gameInfo: null,
		hasLogin: false, //是否登录
    minHeight: ''
	},
	mutations: {
		SET_INFO:(state, gameInfo) => {
			state.gameInfo = gameInfo;
		}
	},
	actions: {
		setInfo({ commit }, info){
			commit('SET_INFO', info)
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js